import OrderStatuses from 'types/enums/OrderStatuses';
import DetailItem from 'types/models/DetailItem';
import Order from 'types/models/Order';

export const calculateTotalAmount = (detail: DetailItem[], discount?: number): number => {
  const prices = detail.map((item) => item.product.price * item.quantity);
  const reducer = (accumulator: number, currentValue: number) => accumulator + currentValue;
  if (discount) {
    const totalWithDiscount = prices.reduce(reducer) - discount;
    if (totalWithDiscount <= 0) {
      return 0;
    } else {
      return totalWithDiscount;
    }
  } else {
    return prices.reduce(reducer, 0);
  }
};

export const getTotalProducts = (detail: DetailItem[]) => {
  let acc = 0;
  for (const item of detail) acc += item.quantity;
  return acc;
};

export const getcolorStatusDescription = (orderStatusId: number) => {
  switch (orderStatusId) {
    case OrderStatuses.created:
      return '#EC1C24';
    case OrderStatuses.delivered:
      return '#00A80E';
    default:
      return '#F8A918';
  }
};

export const getPaymentMethod = (
  order: Order,
): {
  isBalance: boolean;
  isCash: boolean;
  isCourtesy: boolean;
  isFiservQrPayment: boolean;
  isPixPayment: boolean;
  isCardPayment: boolean;
  isMPCheckoutPayment: boolean;
} => {
  const isBalance = Boolean(order.payment?.isBalance);
  const isCash = order.isCash;
  const isCourtesy = order.isCourtesy;
  const isFiservQrPayment = Boolean(order.payment?.fiservQrPayment);
  const isPixPayment =
    Boolean(order.payment?.cloverPointPayment) &&
    ['Mercado Pago', 'Pix'].includes(order.payment?.cloverPointPayment?.paymentMethod || '');
  const isMPCheckoutPayment = Boolean(order.payment?.mpCheckoutPaymentId);
  const isCardPayment = !isBalance && !isCash && !isCourtesy && !isFiservQrPayment && !isPixPayment;

  return {
    isBalance,
    isCash,
    isCourtesy,
    isFiservQrPayment,
    isPixPayment,
    isCardPayment,
    isMPCheckoutPayment,
  };
};

export const formatOrderId = (orderId: number | string, orderStatusId: number, placeholder?: string): string => {
  if (orderStatusId === OrderStatuses.created) {
    return placeholder ?? '*'.repeat(orderId.toString().length);
  }
  return orderId.toString();
};
